import instance from './common';

export const getDecodedStacktrace = <T>(reqBody) =>
  instance.post<T>('/appData/stacktrace/decode', reqBody);
